import GeolocalizacaoFotoConstant from "./GeolocalizacaoFotoConstant";

export default class CoordenadasFotoConstant {
    static COORDENADAS = {
        dataHorarioCoordenadas: null,
        dataHorarioExpiracao: null,
        localizacao: GeolocalizacaoFotoConstant.LOCALIZACAO,
    }
}